import $ from 'jquery';
import delay from 'lodash/delay';

const docBody = $(document.body),
        hamburger = $('.hamburger'),
        mobileNav = $('.nav.menu');


    /**
     * @brief [brief description]
     * @details [long description]
     * 
     * @param  [description]
     * @return [description]
     */
    const rtn = function() {

        hamburger.addClass('is-active');
        mobileNav.addClass('active');
        docBody.addClass('hidden');

        mobileNav.find('li').each(function(i, el) {
            el = $(el);
            delay(function() {
                el.addClass('active');
            }, (100 * (i + 1)));
        })
    }


    module.exports = rtn;


// WEBPACK FOOTER //
// ./js/service/show-mobile-menu.js